export const timelineData = [
    {
        id: 1,
        title: "Frontend Developer", 
        company: "Aladdin Digital bank",
        date: "April 2022 - Present",
        description: "Worked as a frontend developer on the admin dashboard, made admin activities faster by implementing seamless flows and improved the customer engagement and responses by building tables. "
    },
    {
        id: 2,
        title: "Frontend Developer Intern",
        company: "Aladdin Digital bank",
        date: "January 2022 - April 2022",
        description: "Worked as an intern on the admin dashboard, learnt how to implement flows on the dashboard and how to build informing tables. "
    },
    {
        id: 3,
        title: "Frontend Developer",
        company: "Perxels",
        date: "February 2022 - Present ",
        description: "Implemented the frontend of the website, worked on the UI and UX of the website, made the website responsive and made the website SEO friendly. Worked on several projects that inclines to the website"
    },
    {
        id: 4,
        title: "Frontend Developer",
        company: "Veenode Technologies",
        date: "October 2021 - May 2022 ",
        description: "Worked on the frontend of the website, worked on the UI and UX of the website, made the website responsive and made the website SEO friendly. Ran Designs for marketing campains and worked on several projects that inclines to the website"
    },
    {
        id: 5,
        title: "Frontend Developer",
        company: "HNGi8",
        date: "August 2021 - September 2021 ",
        description: "Worked on the frontend of a web3 facing project, implemented several functionalities on the website and collaborated with a large team"
    }

]